import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetAccessToPaymentStatusPage } from "../store/navigationSlice";
import { useSelector } from "react-redux";
import "../styles/PaymentStatus.css";
import orderConfirm from "../assets/order_confirmed.svg";

const PaymentSuccessPage = () => {

    const navigate = useNavigate();
    const [countdown, setCountdown] = useState(10); // 10 seconds countdown
    const dispatch = useDispatch();
    const canAccessPaymentStatusPage = useSelector((state) => state.navigation.canAccessPaymentStatusPage);

    useEffect(() => {
        return () => {
          dispatch(resetAccessToPaymentStatusPage()); // cleanup
        };
    }, [dispatch]);


    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(prevCountdown => {
                if (prevCountdown <= 1) {
                    clearInterval(timer);
                    navigate('/');
                    return 0;
                }
                return prevCountdown - 1;
            });
        }, 1000); // Update every second

        return () => clearInterval(timer); // Cleanup the timer on component unmount
    }, []);

    if (!canAccessPaymentStatusPage) {
        // return <Navigate to="/plans-and-pricing" replace />;
        <div>Invalid!!</div>
    }

    return (
        <div className="payment-success-message">
            <img className='order-confirm-icon' src = {orderConfirm}/>
            <p className='fw700 fs26 green-text'>Order Confirmed</p>
            <p className='fw700 fs20'>Thank you for subscribing to our course. Your journey towards mastering new knowledge begins now!</p>
            <p className='fw700 fs20'>You will be redirected to the dashboard in {countdown} seconds...</p>
        </div>
    );
};

export default PaymentSuccessPage;